module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_7_after.jpg
// module id = 1169
// module chunks = 0